module.exports = __webpack_public_path__ + "img/logo_dark_min.5792f3d7.png";